<template>
  <v-dialog v-model="visible" max-width="1200px">
    <v-form>
      <v-card style="overflow-y: hidden">
        <v-card-title class="py-2 px-4">{{ nombreItem }}</v-card-title>

        <v-divider class="my-0"></v-divider>

        <v-card-text class="pa-4">
          <v-row>
            <v-col cols="12" lg="8">
              <v-row>
                <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="6" class="pa-0">
                  <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
                </v-col>

                <v-col cols="12" v-if="!item.ceubArchivoId">
                  <v-row dense class="mb-2">
                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model.number="horasAcademicasCeub"
                        type="number"
                        min="1"
                        step="1"
                        label="Horas Académicas CEUB *"
                        outlined
                        dense
                        hide-details></v-text-field>
                      <small v-for="error in errores.horasAcademicasCeub" :key="error" class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-text-field
                        v-model.number="numeroCreditosCeub"
                        type="number"
                        min="1"
                        step="1"
                        label="Número de Créditos CEUB *"
                        outlined
                        dense
                        hide-details></v-text-field>
                      <small v-for="error in errores.numeroCreditosCeub" :key="error" class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-menu
                        v-model="menuFechaEmisionCeub"
                        transition="scale-transition"
                        :close-on-content-click="false"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="fechaEmisionCeub"
                            label="Fecha de Emisión CEUB *"
                            prepend-inner-icon="mdi-calendar"
                            outlined
                            dense
                            readonly
                            clearable
                            hide-details
                            v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="fechaEmisionCeub"
                          no-title
                          scrollable
                          @input="menuFechaEmisionCeub = false"></v-date-picker>
                      </v-menu>
                      <small v-for="error in errores.fechaEmisionCeub" :key="error" class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>

                    <v-col v-if="esMaestria" cols="12" sm="6">
                      <v-select
                        v-model="gradoAcademicoCeub"
                        :items="gradosAcademicosCeubOpciones"
                        item-text="text"
                        item-value="value"
                        label="Grado Académico CEUB *"
                        outlined
                        dense
                        hide-details></v-select>
                      <small v-for="error in errores.gradoAcademicoCeub" :key="error" class="d-block text-danger">
                        {{ error }}
                      </small>
                    </v-col>
                  </v-row>

                  <v-file-input
                    v-model="archivo"
                    class="file-input"
                    label="Adjuntar CEUB (PDF, JPG, PNG)"
                    accept="image/jpeg, image/png, image/jpg, application/pdf"
                    :prepend-icon="''"
                    prepend-inner-icon="mdi-paperclip"
                    outlined
                    dense
                    clearable
                    hide-details
                    @change="onFileChange"></v-file-input>

                  <small class="d-block text-muted"> Formatos permitidos: JPG, PNG, PDF </small>

                  <small v-for="error in errores.archivoBase64" :key="error" class="d-block text-danger">
                    {{ error }}
                  </small>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" lg="4">
              <div class="d-flex justify-center align-center contenedor-previsualizacion">
                <v-progress-circular v-if="cargandoCEUB" indeterminate color="primary" size="50"></v-progress-circular>

                <template v-if="!cargandoCEUB">
                  <template v-if="previsualizacion && esImagen">
                    <v-img :src="previsualizacion" aspect-ratio="1" contain height="400px"></v-img>
                    <v-btn
                      v-if="item.ceubArchivoId"
                      style="position: absolute; bottom: 15px; right: 15px; z-index: 1"
                      color="primary"
                      small
                      @click.prevent="descargarArchivo(previsualizacion, `CEUB_${item.codigo}_${item.programaNombre}`)">
                      <v-icon>mdi-download</v-icon>

                      Descargar
                    </v-btn>
                  </template>

                  <iframe v-else-if="previsualizacion && esPDF" :src="previsualizacion" height="400px"></iframe>

                  <v-icon v-else>mdi-image-broken-variant</v-icon>
                </template>
              </div>
            </v-col>

            <v-col cols="2"> </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-0"></v-divider>

        <v-card-actions>
          <v-btn
            v-if="!item.ceubArchivoId"
            color="primary"
            text
            :disabled="enviando"
            :loading="enviando"
            @click.prevent="$refs.confirmacionRef.abrir()">
            <v-icon left>mdi-content-save</v-icon>

            Guardar
          </v-btn>

          <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <ConfirmacionAccion
      ref="confirmacionRef"
      :titulo="confirmacion.titulo"
      :mensaje="confirmacion.mensaje"
      :realizandoAccion="confirmacion.realizandoAccion"
      @aceptar="confirmacion.fnAceptar" />
  </v-dialog>
</template>

<script>
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';
import { concatenar, normalizarTexto, formatearFechaCadena } from '../utils/funciones';
import {
  CATEGORIA_UNIVERSIDAD_MAESTRIA,
  gradosAcademicosCeubOpciones,
  GradosAcademicosCeubLabels,
} from '../utils/constantes';
import ProgramaUniversidadService from '../services/programa-universidad.service';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';

export default {
  name: 'ModalFormAgregarCEUB',
  mixins: [programaUniversidadMixin],
  components: {
    ConfirmacionAccion,
  },
  watch: {
    archivoBase64: function () {
      this.errores.archivoBase64 = [];
    },
    horasAcademicasCeub() {
      this.errores.horasAcademicasCeub = [];
    },
    numeroCreditosCeub() {
      this.errores.numeroCreditosCeub = [];
    },
    fechaEmisionCeub() {
      this.errores.fechaEmisionCeub = [];
    },
    gradoAcademicoCeub() {
      this.errores.gradoAcademicoCeub = [];
    },
  },
  computed: {
    esMaestria() {
      return normalizarTexto(this.item.categoriaUniversidad?.nombre) === CATEGORIA_UNIVERSIDAD_MAESTRIA;
    },
    listado() {
      const items = [
        { nombre: 'Código', valor: this.item.codigo },
        { nombre: 'Nombre Programa', valor: this.item.programaNombre },
        { nombre: 'Área', valor: this.item.areaUniversidad?.nombre },
        { nombre: 'Tipo', valor: this.item.categoriaUniversidad?.nombre },
        {
          nombre: 'Gestión / Versión / Grupo',
          valor: `${this.item.gestion} / ${this.item.version} / ${this.item.grupo || '-'}`,
        },
        { nombre: 'Resol. Aprob. Univ.', valor: this.item.resolucionAprobacionUniversidad },
        { nombre: 'Sede Universidad', valor: this.item.sedeUniversidad?.nombre },
        { nombre: 'Estado', valor: this.item.estado?.toUpperCase() },
        { nombre: 'Plan de Pago', valor: this.item.planPagoUniversidad?.nombre || 'No asignado' },
      ];

      if (this.item.ceubArchivoId) {
        items.push(
          { nombre: 'Horas Académicas CEUB', valor: this.item.horasAcademicasCeub ?? '-' },
          { nombre: 'Número de Créditos CEUB', valor: this.item.numeroCreditosCeub ?? '-' },
          { nombre: 'Fecha de Emisión CEUB', valor: formatearFechaCadena(this.item.fechaEmisionCeub) || '-' },
        );
        if (this.esMaestria) {
          items.push({
            nombre: 'Grado Académico CEUB',
            valor: GradosAcademicosCeubLabels[this.item.gradoAcademicoCeub] || '-',
          });
        }
        items.push({ nombre: 'Subido por', valor: this.item.ceubSubidoPorNombre || '-' });
      }

      return items;
    },
    sedeUniversidad() {
      return this.item.sedeUniversidad;
    },
  },
  data() {
    return {
      visible: false,
      item: this.generarObjetoFormRegistrar(),
      nombreItem: 'Programa Universidad',
      archivo: null,
      archivoBase64: null,
      horasAcademicasCeub: null,
      numeroCreditosCeub: null,
      fechaEmisionCeub: null,
      gradoAcademicoCeub: null,
      menuFechaEmisionCeub: false,
      gradosAcademicosCeubOpciones,
      previsualizacion: null,
      esImagen: false,
      esPDF: false,
      cargandoCEUB: false,
      confirmacion: {
        titulo: 'Subir CEUB',
        mensaje: '¿Está seguro que desea subir el CEUB? Esta acción no se puede deshacer.',
        realizandoAccion: false,
        fnAceptar: () => this.guardar(),
      },
    };
  },
  methods: {
    abrir(data = null) {
      this.archivo = null;
      this.archivoBase64 = null;
      this.horasAcademicasCeub = null;
      this.numeroCreditosCeub = null;
      this.fechaEmisionCeub = null;
      this.gradoAcademicoCeub = null;
      this.menuFechaEmisionCeub = false;
      this.previsualizacion = null;
      this.esImagen = false;
      this.esPDF = false;
      this.item = this.generarObjetoFormEditar(data);

      if (this.item.ceubArchivoId) {
        this.cargandoCEUB = true;

        ProgramaUniversidadService.obtenerCEUB(this.item.id)
          .then((response) => {
            const data = response?.data;
            const datos = data?.datos;

            if (datos) {
              this.archivo = null;
              this.archivoBase64 = datos.file64;

              if (datos.mimetype.includes('image')) {
                this.esImagen = true;
                this.esPDF = false;
                this.previsualizacion = `data:${datos.mimetype};base64,${datos.file64}`;
              } else if (datos.mimetype === 'application/pdf') {
                this.esImagen = false;
                this.esPDF = true;
                const byteCharacters = atob(datos.file64);
                const byteNumbers = new Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                  byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: datos.mimetype });
                this.previsualizacion = URL.createObjectURL(blob);
              } else {
                this.esImagen = false;
                this.esPDF = false;
                this.previsualizacion = null;
              }
            }
          })
          .finally(() => {
            this.cargandoCEUB = false;
          });
      }

      this.visible = true;
    },
    cerrar() {
      this.visible = false;
    },
    onFileChange() {
      if (this.archivo) {
        const reader = new FileReader();
        const fileType = this.archivo.type;

        reader.onload = (e) => {
          const result = e.target.result;
          this.archivoBase64 = result.split(',')[1];

          if (fileType.includes('image')) {
            this.previsualizacion = result;
            this.esImagen = true;
            this.esPDF = false;
          } else if (fileType === 'application/pdf') {
            const blob = new Blob([this.archivo], { type: fileType });
            this.previsualizacion = URL.createObjectURL(blob);
            this.esImagen = false;
            this.esPDF = true;
          } else {
            this.previsualizacion = null;
            this.esImagen = false;
            this.esPDF = false;
          }
        };

        reader.readAsDataURL(this.archivo);
      } else {
        this.previsualizacion = null;
        this.esImagen = false;
        this.esPDF = false;
        this.archivoBase64 = null;
      }
    },
    async guardar() {
      const erroresLocales = {};
      const esEnteroPositivo = (v) => Number.isInteger(Number(v)) && Number(v) >= 1;
      const esFechaISO = (v) => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v);

      if (!this.archivoBase64) {
        erroresLocales.archivoBase64 = ['Debe adjuntar el archivo del CEUB.'];
      }
      if (!esEnteroPositivo(this.horasAcademicasCeub)) {
        erroresLocales.horasAcademicasCeub = ['Debe ser un entero mayor o igual a 1.'];
      }
      if (!esEnteroPositivo(this.numeroCreditosCeub)) {
        erroresLocales.numeroCreditosCeub = ['Debe ser un entero mayor o igual a 1.'];
      }
      if (!esFechaISO(this.fechaEmisionCeub)) {
        erroresLocales.fechaEmisionCeub = ['Debe seleccionar una fecha válida.'];
      }
      if (this.esMaestria && !this.gradoAcademicoCeub) {
        erroresLocales.gradoAcademicoCeub = ['Debe seleccionar el grado académico.'];
      }

      if (Object.keys(erroresLocales).length > 0) {
        this.errores = erroresLocales;
        return;
      }

      this.enviando = true;
      this.confirmacion.realizandoAccion = true;

      try {
        const payload = {
          archivoBase64: this.archivoBase64,
          ceubSubidoPorId: this.$store.state.DATA_USER.id,
          ceubSubidoPorNombre: concatenar(
            this.$store.state.DATA_USER.nombres,
            this.$store.state.DATA_USER.pri_apellido,
            this.$store.state.DATA_USER.seg_apellido,
          ),
          horasAcademicasCeub: this.horasAcademicasCeub,
          numeroCreditosCeub: this.numeroCreditosCeub,
          fechaEmisionCeub: this.fechaEmisionCeub,
        };
        if (this.esMaestria) {
          payload.gradoAcademicoCeub = this.gradoAcademicoCeub;
        }
        const response = await ProgramaUniversidadService.agregarCEUB(this.item.id, payload);
        const data = response?.data;
        const mensaje = data?.mensaje;

        this.$notify({
          group: 'notifications',
          title: 'Éxito',
          text: mensaje || 'CEUB subido con éxito.',
          type: 'success',
        });
        this.$emit('actualizarListado');
        this.cerrar();
      } catch (error) {
        window.console.log({ error });
        const data = error?.response?.data;
        const mensaje = data?.mensaje;
        const errores = data?.errores;

        if (errores) {
          this.errores = errores;
        }

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Ocurrió un error al subir el CEUB.',
          type: 'error',
        });
      } finally {
        this.enviando = false;
        this.confirmacion.realizandoAccion = false;
      }
    },
    descargarArchivo(url, nombre) {
      const link = document.createElement('a');
      link.href = url;
      link.download = nombre;
      link.click();
    },
  },
};
</script>

<style scoped>
.contenedor-previsualizacion {
  border: 1px solid #c5c5c5;
  border-radius: 5px;
  padding: 10px;
  height: 420px;
  max-height: 420px;
  background-color: #f5f5f5;
}

.contenedor-previsualizacion iframe {
  border: none;
}
</style>